/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuggestedPrimaryIdentifierResource
 */
export interface SuggestedPrimaryIdentifierResource {
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrimaryIdentifierResource
     */
    primaryIdentifierType: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrimaryIdentifierResource
     */
    primaryIdentifierValue: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SuggestedPrimaryIdentifierResource
     */
    availableIdentifierTypes: Array<string>;
}

/**
 * Check if a given object implements the SuggestedPrimaryIdentifierResource interface.
 */
export function instanceOfSuggestedPrimaryIdentifierResource(value: object): value is SuggestedPrimaryIdentifierResource {
    if (!('primaryIdentifierType' in value) || value['primaryIdentifierType'] === undefined) return false;
    if (!('primaryIdentifierValue' in value) || value['primaryIdentifierValue'] === undefined) return false;
    if (!('availableIdentifierTypes' in value) || value['availableIdentifierTypes'] === undefined) return false;
    return true;
}

export function SuggestedPrimaryIdentifierResourceFromJSON(json: any): SuggestedPrimaryIdentifierResource {
    return SuggestedPrimaryIdentifierResourceFromJSONTyped(json, false);
}

export function SuggestedPrimaryIdentifierResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestedPrimaryIdentifierResource {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryIdentifierType': json['primaryIdentifierType'],
        'primaryIdentifierValue': json['primaryIdentifierValue'],
        'availableIdentifierTypes': json['availableIdentifierTypes'],
    };
}

export function SuggestedPrimaryIdentifierResourceToJSON(value?: SuggestedPrimaryIdentifierResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'primaryIdentifierType': value['primaryIdentifierType'],
        'primaryIdentifierValue': value['primaryIdentifierValue'],
        'availableIdentifierTypes': value['availableIdentifierTypes'],
    };
}

